import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    installmentList: [],
    totalRecords: 0,
    installmentDetails: {},
    message: null,
}

export const installmentReducerSlice = createSlice({
    name: 'installment',
    initialState,
    reducers: {
        getInstallmentList: (state, action) => {
            state.installmentList = action.payload.data?.data;
            state.totalRecords = action.payload.data?.totalRecord;
            state.message = action.payload.message;
        },
        getInstallmentDetails: (state, action) => {
            state.installmentDetails = action.payload
        },
        resetInstallmentDetails: (state, action) => {
            state.installmentDetails = {}
        },

    },
})

// Action creators are generated for each case reducer function
export const { getInstallmentList, getInstallmentDetails ,resetInstallmentDetails} = installmentReducerSlice.actions

export default installmentReducerSlice.reducer;